module.exports = __webpack_public_path__ + "img/34c-config-modelos-doc-wizard-calculo.b4f3be30.png";